import projectContext from './projectContext/projectContext';
import userManagement from './userManagement/userManagement';
import myProfile from './myProfile/myProfile';
import projectManagement from './projectManagement/projectManagement';
import projectClone from './projectManagement/projectClone';

import {
	GeneralActions,
	ProjectContextActions,
	ClientUserManagementActions,
	ProjectManagementActions,
	AuthActionTypes,
} from '../../actions';
import dataService from '../../../services/data/userContextDataService';

const Mutations = Object.freeze({
	SET_CLIENTS: 'clientContext/SET_CLIENTS',
	SET_SELECTED_CLIENT: 'clientContex/SET_SELECTED_CLIENT',
	SET_INITIALIZED: 'clientContex/SET_INITIALIZED',
});

export const Actions = Object.freeze({
	LOAD_CLIENT_CONTEXT: 'clientContext/LOAD_CLIENT_CONTEXT',
	RELOAD_CLIENT_CONTEXT: 'clientContext/RELOAD_CLIENT_CONTEXT',
	UPDATE_SELECTED_CLIENT: 'clientContext/UPDATE_SELECTED_CLIENT',
	CLEAR: 'clientContext/CLEAR',
});

export const Getters = Object.freeze({
	CLIENTS: 'clientContext/CLIENTS',
	SELECTED_CLIENT: 'clientContext/SELECTED_CLIENT',
	HAS_CLIENT: 'clientContext/HAS_CLIENT',
	INITIALIZE: 'clientContext/INITIALIZE',
});

export default {
	state: {
		clients: [],
		selectedClient: null,
		isInitialized: false,
	},
	modules: {
		myProfile,
		projectContext,
		projectClone,
		projectManagement,
		userManagement,
	},
	mutations: {
		[Mutations.SET_INITIALIZED](state, value) {
			state.isInitialized = value;
		},
		[Mutations.SET_CLIENTS](state, items) {
			state.clients = items;
		},
		[Mutations.SET_SELECTED_CLIENT](state, item) {
			state.selectedClient = item;
		},
		[Mutations.SET_INITIALIZED](state, value) {
			state.isInitialized = value;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				Promise.all([
					dispatch(ProjectContextActions.CLEAR),
					dispatch(ProjectManagementActions.CLEAR),
					dispatch(ClientUserManagementActions.CLEAR),
				]).then(() => {
					commit(Mutations.SET_CLIENTS, []);
					commit(Mutations.SET_SELECTED_CLIENT, null);
					commit(Mutations.SET_INITIALIZED, false);
					resolve();
				});
			});
		},
		[Actions.LOAD_CLIENT_CONTEXT]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				Promise.all([
					dispatch(AuthActionTypes.LOAD_PROFILE),
					dataService
						.getClients()
						.then((resp) => {
							commit(Mutations.SET_CLIENTS, resp.data);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
						}),
					dataService
						.getSelectedClient()
						.then((resp) => {
							if (resp.data) {
								commit(
									Mutations.SET_SELECTED_CLIENT,
									resp.data
								);
								return dispatch(
									ProjectContextActions.LOAD_PROJECT_CONTEXT
								);
							}
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
						}),
				])
					.then(() => {
						commit(Mutations.SET_INITIALIZED, true);
						resolve(true);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_SELECTED_CLIENT]({ dispatch }, item) {
			return new Promise((resolve, reject) => {
				dataService
					.updateSelectedClient(item)
					.then(() => {
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						reject(error);
					});
			});
		},
		[Actions.RELOAD_CLIENT_CONTEXT]({ dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dispatch(Actions.CLEAR)
					.then(() => {
						return dispatch(Actions.LOAD_CLIENT_CONTEXT);
					})
					.then(() => {
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.CLIENTS]: (state) => {
			return JSON.parse(JSON.stringify(state.clients));
		},

		[Getters.SELECTED_CLIENT]: (state) => {
			if (!state.selectedClient) return null;
			return JSON.parse(JSON.stringify(state.selectedClient));
		},
		[Getters.HAS_CLIENT]: (state) => {
			return state.selectedClient != null;
		},
		[Getters.INITIALIZE]: (state) => {
			return state.isInitialized;
		},
	},
};
